module.exports = __webpack_public_path__ + "media/images/Canada-bride-image2-b1178547fe595df533eae09a90d0cb8d.jpg";